import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { TabContainer, TabButton } from './styled';

export type PeriodType = 'last_7' | 'last_30' | 'last_90';

interface PeriodFilterTabsProps {
  period: PeriodType;
  onPeriodChange: (period: PeriodType) => void;
}

const PeriodFilterTabs: React.FC<PeriodFilterTabsProps> = ({ period, onPeriodChange }) => {
  const { t } = useTranslation('payment-and-invoices');

  const tabs: { id: PeriodType; label: string }[] = [
    { id: 'last_7', label: t('last_7_days') },
    { id: 'last_30', label: t('last_30_days') },
    { id: 'last_90', label: t('last_90_days') },
  ];

  return (
    <TabContainer>
      {tabs.map((tab) => (
        <TabButton key={tab.id} isActive={period === tab.id} onClick={() => onPeriodChange(tab.id)}>
          {tab.label}
        </TabButton>
      ))}
    </TabContainer>
  );
};

export default PeriodFilterTabs;
